import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import TrackableLink from 'components/TrackableLink';
import config from 'config';
import en from 'intl/translations/en';

const CamHeaderCTA = ({ href = config.funnelUrl, segmentProperties = {} }) => {
  const ref = useRef();
  return (
    <div className="sl-cam-header-cta">
      <span className="sl-cam-header-cta__text">{en.premiumCTA.CamHeaderCTA.text}</span>
      <TrackableLink
        ref={ref}
        eventName="Clicked Subscribe CTA"
        eventProperties={segmentProperties}
      >
        <a ref={ref} href={href} className="sl-cam-header-cta__link">
          {en.premiumCTA.CamHeaderCTA.linkText}
        </a>
      </TrackableLink>
    </div>
  );
};

CamHeaderCTA.propTypes = {
  href: PropTypes.string,
  segmentProperties: PropTypes.shape({}),
};

export default CamHeaderCTA;
